import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { ApiError } from "../api/client";

// One wrapper so every page fetches the same way: no retry on a refusal (403/401 will not succeed by trying again),
// one retry on anything else.

export function useApiQuery<T>(
  key: readonly unknown[],
  fetcher: () => Promise<T>,
  options?: Omit<UseQueryOptions<T, ApiError, T, readonly unknown[]>, "queryKey" | "queryFn">
): UseQueryResult<T, ApiError> {
  return useQuery<T, ApiError, T, readonly unknown[]>({
    queryKey: key,
    queryFn: fetcher,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && (error.status === 401 || error.status === 403 || error.status === 404)) return false;
      return failureCount < 1;
    },
    ...options
  });
}
